import { accessPermissionProfile } from "./permissionProfiles/accessPermissionProfile"
import { activityPermissionProfile } from "./permissionProfiles/activityPermissionProfile"
import { assetsPermissionProfiles } from "./permissionProfiles/assetsPermissionProfile"
import { auditPermissionProfile } from "./permissionProfiles/auditPermissionProfile"
import { carrierPermissionProfile } from "./permissionProfiles/carrierPermissionProfile"
import { clientConfigPermissionProfile } from "./permissionProfiles/clientConfigPermissionProfile"
import { conditionReportPermissionProfile } from "./permissionProfiles/conditionReportPermissionProfile"
import { dashboardPermissionProfiles } from "./permissionProfiles/dashboardPermissionProfiles"
import { flagsPermissionProfile } from "./permissionProfiles/flagsPermissionProfile"
import { formPermissionProfiles } from "./permissionProfiles/formPermissionProfiles"
import { inspectionPermissionProfile } from "./permissionProfiles/inspectionPermissionProfile"
import { inventoryPermissionProfile } from "./permissionProfiles/inventoryPermissionProfile"
import { invoicePermissionProfile } from "./permissionProfiles/invoicePermissionProfile"
import { issueTrackerPermissionProfile } from "./permissionProfiles/issueTrackerPermissionProfile"
import { loadPermissionProfiles } from "./permissionProfiles/loadPermissionProfiles"
import { lotPermissionProfiles } from "./permissionProfiles/lotPermissionProfile"
import { mechanicalsPermissionProfile } from "./permissionProfiles/mechanicalsPermissionProfile"
import { mechanicalTaskPermissionProfiles } from "./permissionProfiles/mechanicalTaskPermissionProfiles"
import { mobilePermissionProfiles } from "./permissionProfiles/mobilePermissionProfiles"
import { notesPermissionProfiles } from "./permissionProfiles/notesPermissionProfiles"
import { pricingPermissionProfile } from "./permissionProfiles/pricingPermissionProfile"
import { reportsPermissionProfile } from "./permissionProfiles/reportsPermissionProfile"
import { reservationPermissionProfile } from "./permissionProfiles/reservationPermissionProfile"
import { SubscriptionPermissionProfiles } from "./permissionProfiles/subscriptionPermissionProfiles"
import { tasksPermissionProfile } from "./permissionProfiles/tasksPermissionProfile"
import { taxRatePermissionProfile } from "./permissionProfiles/taxRatePermissionProfile"
import { transporterPermissionProfiles } from "./permissionProfiles/transporterPermissionProfiles"
import { userManagementPermissionProfiles } from "./permissionProfiles/userManagementPermissionProfiles"
import { userPermissionProfiles } from "./permissionProfiles/userPermissionProfiles"
import { saasManagementPermissionProfiles } from "./permissionProfiles/saasManagementPermissionProfiles"
import { vendorPermissionProfile } from "./permissionProfiles/vendorPermissionProfile"
import { workRequestPermissionProfile } from "./permissionProfiles/workRequestPermissionProfile"

export const permissionProfiles = {
    SAAS_MANAGEMENT: { ...saasManagementPermissionProfiles },
    ASSETS: { ...assetsPermissionProfiles },
    LOAD: { ...loadPermissionProfiles },
    SUBSCRIPTION: { ...SubscriptionPermissionProfiles },
    USER: { ...userPermissionProfiles },
    USER_MANAGEMENT: { ...userManagementPermissionProfiles },
    LOT: { ...lotPermissionProfiles },
    CLIENT_CONFIG: { ...clientConfigPermissionProfile },
    TASKS: { ...tasksPermissionProfile },
    DASHBOARD: { ...dashboardPermissionProfiles },
    TRANSPORTER: { ...transporterPermissionProfiles },
    INVOICE: { ...invoicePermissionProfile },
    INSPECTION: { ...inspectionPermissionProfile },
    AUDIT: { ...auditPermissionProfile },
    ISSUETRACKER: { ...issueTrackerPermissionProfile },
    ACTIVITY: { ...activityPermissionProfile },
    MECHANICALS_CONFIG: { ...mechanicalsPermissionProfile },
    MECHANICALS_TASKS: { ...mechanicalTaskPermissionProfiles },
    CONDITION_REPORT: { ...conditionReportPermissionProfile },
    MOBILE: { ...mobilePermissionProfiles },
    NOTES: { ...notesPermissionProfiles },
    PRICING: { ...pricingPermissionProfile },
    ACCESS: { ...accessPermissionProfile },
    INVENTORY: { ...inventoryPermissionProfile },
    FORMS: { ...formPermissionProfiles },
    REPORTS: { ...reportsPermissionProfile },
    TAX_RATE: { ...taxRatePermissionProfile },
    RESERVATIONS: { ...reservationPermissionProfile },
    CARRIERS: { ...carrierPermissionProfile },
    FLAGS: { ...flagsPermissionProfile },
    VENDOR: { ...vendorPermissionProfile },
    WORK_REQUEST: { ...workRequestPermissionProfile }
}